import type { ActiveTrainingBlock } from '../training/training-scoring'
import { describeTrainingAnswer } from '../training/training-scoring'

/** Checked when displaying or acting on a question, never stored on learner rows. */
export function questionSourceValid(parts: ActiveTrainingBlock[]) {
  return parts.length > 0 && parts.every(part => {
    if (part.type === 'cloze') {
      const answer = describeTrainingAnswer(part).trim()
      return answer.length > 0 && !/\{\{\s*\}\}/u.test(answer)
    }
    switch (part.subtype) {
      case 'la': return part.criteria.some(value => typeof value === 'string' && value.trim().length > 0)
      case 'sc': return Number.isInteger(part.answer) && part.answer >= 0 && part.answer < part.opts.length
      case 'mc': return part.answer.length > 0 && part.answer.every(value => Number.isInteger(value) && value >= 0 && value < part.opts.length)
      case 'sr': return part.answer.transcript.trim().length > 0
      case 'sa': return part.answer.some(value => typeof value === 'string' && value.trim().length > 0)
      default: return false
    }
  })
}
